
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/chinh-sach-dam-bao-atttcn",
      function () {
        return require("private-next-pages/admin/chinh-sach-dam-bao-atttcn/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/chinh-sach-dam-bao-atttcn"])
      });
    }
  